// Centralised WC round labelling — shared by all dashboard/tipping/history surfaces.
// Group stage = rounds 1-3 ("Group Matchday N"). Knockout rounds get the canonical
// FIFA names.

export function wcRoundLabel(roundNumber) {
  const labels = {
    1: 'Group Matchday 1',
    2: 'Group Matchday 2',
    3: 'Group Matchday 3',
    4: 'Round of 32',
    5: 'Round of 16',
    6: 'Quarter Finals',
    7: 'Semi Finals',
    8: 'Third Place Play Off',
    9: 'Final',
  };
  if (roundNumber === 0) return 'Opening Round';
  return labels[roundNumber] ?? `Round ${roundNumber}`;
}

export function aflRoundLabel(roundNumber) {
  // AFL 2026 finals series naming
  const finals = {
    25: 'Wildcard Round',
    26: 'Qualifying & Elimination Finals',
    27: 'Semi Finals',
    28: 'Preliminary Finals',
    29: 'Grand Final',
  };
  if (roundNumber === 0) return 'Opening Round';
  return finals[roundNumber] ?? `Round ${roundNumber}`;
}

export function nrlRoundLabel(roundNumber) {
  // NRL 2026 finals series naming (mirrors AFL finals structure)
  const finals = {
    28: 'Finals Week 1',
    29: 'Semi Finals',
    30: 'Preliminary Finals',
    31: 'Grand Final',
  };
  if (roundNumber === 0) return 'Opening Round';
  return finals[roundNumber] ?? `Round ${roundNumber}`;
}

export function roundLabel(sport, roundNumber) {
  if (sport === 'WC') return wcRoundLabel(roundNumber);
  if (sport === 'AFL') return aflRoundLabel(roundNumber);
  if (sport === 'NRL') return nrlRoundLabel(roundNumber);
  if (roundNumber === 0) return 'Opening Round';
  return `Round ${roundNumber}`;
}
